export default __webpack_public_path__ + "static/media/createCollectionsDark@2x.05de70a6.png";